import {
  PLAYER_LIVE_HIDE_LANGUAGE_OPTIONS,
  PLAYER_LIVE_SHOW_LANGUAGE_OPTIONS,
  SET_LIVE_AVAILABLE_CAPTIONS,
  SET_LIVE_AVAILABLE_LANGUAGES,
  PLAYER_MODALS_Z_INDEX_INCREASE,
  PLAYER_MODALS_Z_INDEX_DECREASE,
  SET_TARGET_AUDIO,
} from 'containers/Player/actions/optionButtons/constants';
import { EPG_CLEAR_CHANNEL_EVENT } from '../liveMenu/constants';

export const setAvailableLanguages = availableLanguages => ({
  type: SET_LIVE_AVAILABLE_LANGUAGES,
  availableLanguages,
});

export const setAvailableCaptions = availableCaptions => ({
  type: SET_LIVE_AVAILABLE_CAPTIONS,
  availableCaptions,
});

export const showLanguageOptions = showChevron => dispatch => {
  
  dispatch({
    type: PLAYER_MODALS_Z_INDEX_INCREASE,
  });
  dispatch({
    type: PLAYER_LIVE_SHOW_LANGUAGE_OPTIONS,
    showChevron,
  });
};

export const hideLanguageOptions = () => (dispatch, getState) => {
  const state = getState();
  if (state.Player.OptionButtons.languageOptions.isOpen) {
    dispatch({
      type: PLAYER_MODALS_Z_INDEX_DECREASE,
    });
    dispatch({
      type: PLAYER_LIVE_HIDE_LANGUAGE_OPTIONS,
    });
  }
};

export const setCurrentAudioLanguage = currentAudioLanguage => ({
  type: 'SET_LIVE_CURRENT_AUDIO_LANGUAGE',
  currentAudioLanguage,
});

export const setTargetAudioLanguage = (targetAudioLanguage, cb) => dispatch => {
  dispatch({
    type: 'SET_VOD_TARGET_LANGUAGE',
    targetAudioLanguage,
  });
  cb();
};
